export const API_URL = process.env.NODE_ENV === "staging" ? 'https://api.resq-app.com' : 'https://api-stage.resq-app.com';
// export const API_URL = process.env.REACT_APP_API;
 